import { combineReducers } from '@reduxjs/toolkit'

import schoolReducer from './school'
import districtReducer from './district'
import campusReducer from './campus'
import buildingReducer from './building'
import buildingRoomReducer from './building-room'
import bellScheduleReducer from './bell-schedule'
import bellSchedulePeriodReducer from './bell-schedule-period'
import academicYearReducer from './academic-year'
import markingPeriodReducer from './marking-period'
import schoolEnrollmentReducer from './school-enrollment'
import roleReducer from './role'
import gradeLevelSectionReducer from './grade-level-section'
import gradingScaleReducers from './grading-scale'
import evaluationReducer from './evaluation'
import periodReducer from './periods'
import roomReducer from './room'
import gradingLetterReducers from './grading-letter'
import serviceAccessReducer from './service-access'

const combinedReducer = combineReducers({
  school: schoolReducer,
  schoolEnrollment: schoolEnrollmentReducer,
  district: districtReducer,
  building: buildingReducer,
  buildingRoom: buildingRoomReducer,
  campus: campusReducer,
  academicYear: academicYearReducer,
  markingPeriod: markingPeriodReducer,
  bellSchedule: bellScheduleReducer,
  bellSchedulePeriod: bellSchedulePeriodReducer,
  role: roleReducer,
  gradeLevelSection: gradeLevelSectionReducer,
  gradingScale: gradingScaleReducers,
  evaluations: evaluationReducer,
  period: periodReducer,
  room: roomReducer,
  gradingLetter: gradingLetterReducers,
  serviceAccess: serviceAccessReducer,
})

export default combinedReducer
